<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['子账号管理', title + '子账号']"/>
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <p class="info-text">基本信息</p>
        <el-form
            ref="form"
            class="add-form"
            :rules="rules"
            :model="form"
            label-width="140px"
        >
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="8">
              <el-form-item label="姓名：" prop="name">
                <el-input v-model="form.name" placeholder=""></el-input>
              </el-form-item>
              <el-form-item label="登录手机号：" prop="mobile">
                <el-input v-model="form.mobile" placeholder="">
                  <template slot="append"><i class="el-icon-mobile-phone"></i></template>
                </el-input>
              </el-form-item>
              <el-form-item label="登录邮箱：" prop="username">
                <el-input v-model="form.username" placeholder=""></el-input>
              </el-form-item>
              <el-form-item label="职位：" prop="position">
                <el-input v-model="form.duty" placeholder=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="info-footer">
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click="back">取消</el-button>
        </div>
      </el-card>
    </div>

    <el-dialog
        title="修改密码"
        class="edit-password"
        :visible.sync="dialogVisible"
        width="30%">
      <el-row type="flex" justify="center">
        <el-col :span="18">
          <el-form :model="passwordForm" :rules="passwordFormRules" class="password-form" ref="passwordForm"
                   label-width="120px">
            <el-form-item label="输入新密码" prop="password">
              <el-input v-model="passwordForm.password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="passwordAgain">
              <el-input v-model="passwordForm.passwordAgain" type="password"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelEdit">取 消</el-button>
        <el-button type="primary" @click="saveEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import navHeader from '../../components/navHeader.vue'
import uploadImage from '../../components/uploadImage.vue'

export default {
  data () {
    const checkPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error('密码不能为空！'))
      } else {
        callback()
      }
    }
    const checkPwdAgain = (rule, value, callback) => {
      if (value !== this.passwordForm.password) {
        callback(new Error('两次密码输入不一致！'))
      } else if (!value) {
        callback(new Error('确认密码不能为空！'))
      } else {
        callback()
      }
    }
    return {
      id: '',
      title: '添加',
      dialogVisible: false,
      loading: true,
      passwordType: 'password',
      companyId: sessionStorage.getItem('companyId'),
      type: '',
      form: {
        name: '',
        lockFlag: '',
        phone: '',
        email: '',
        account: '',
        sex: '',
        duty: '',
        remark: ''
      },
      rules: {
        name: {
          required: true,
          message: '请输入中文名',
          trigger: 'blur'
        },
        mobile: {
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        },
        username: [
          {
            required: true,
            message: '请输入账号'
          },
          {
            validator: function (rule, value, callback) {
              let regx = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{0,}$/
              let reg = /[A-z]$/
              if (regx.test(value) || reg.test(value)) {
                callback()
              } else {
                callback(new Error('请输入英文和字母'))
              }
            },
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: false
          },
          {
            validator: function (rule, value, callback) {
              if (!value) {
                callback()
              } else if (value && (/@/.test(value))) {
                callback()
              } else {
                callback(new Error('请输入正确的邮箱格式'))
              }
            },
            trigger: 'blur'
          }
        ]

      },
      passwordForm: {
        password: '',
        passwordAgain: ''
      },
      passwordFormRules: {
        password: {required: true, validator: checkPwd, trigger: 'blur'},
        passwordAgain: {required: true, validator: checkPwdAgain, trigger: 'blur'}
      },
      sexList: [
        {
          label: '男',
          value: 0
        },
        {
          label: '女',
          value: 1
        },
        {
          label: '未知',
          value: 2
        }
      ],
      currentPage: 1,
      pageSize: 10
    }
  },
  components: {
    navHeader,
    uploadImage
  },
  created () {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.getDetail(this.id)
    } else {
      this.id = ''
    }
    if (this.$route.params.type === 'edit') {
      this.type = this.$route.params.type
      this.title = '编辑'
    } else {
      this.type = 'add'
      this.loading = false
      this.title = '添加'
    }
    this.getExhibitionRoleList()
    this.getExhibitionMenuList()
  },
  methods: {
    getDetail (id) {
      this.$http.post('/subAccount/getById', {id}).then(res => {
        if (res.data.code === '200') {
          this.form = res.data.data
        }
        this.loading = false
      }).catch(e => {
        console.log(e)
        this.loading = false
      })
    },
    getExhibitionRoleList () {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      this.$http.post('/api/role/getExhibitionRoleList', params).then(res => {
        console.log(res)
      }).catch(e => {
        console.log(e)
        this.loading = false
      })
    },
    getExhibitionMenuList () {
      this.$http.get('/api/permission/getExhibitionMenuList').then(res => {
        console.log(res)
      })
    },
    back () {
      this.$router.push('/childrenAccount')
    },
    changePasswordType () {
      this.passwordType = this.passwordType === 'password' ? '' : 'password'
    },
    editPassword () {
      this.dialogVisible = true
    },
    cancelEdit () {
      this.dialogVisible = false
      this.$nextTick(() => {
        this.$refs.passwordForm.resetFields()
      })
    },
    saveEdit () {
      this.$refs.passwordForm.validate(async valid => {
        if (valid) {
          this.passwordForm.id = this.id
          delete this.passwordForm.passwordAgain
          let {data: res} = await this.$http.post('subAccount/modifyPassword', this.passwordForm)
          if (res.code === '200') {
            this.$message.success(res.msg)
            this.dialogVisible = false
            this.$nextTick(() => {
              this.$refs.passwordForm.resetFields()
            })
          } else {
            this.$message.error(res.msg)
          }
        }
      })
    },
    save () {
      this.$refs.form.validate((val) => {
        console.log(this.companyId / 1000)
        if (val) {
          let params = JSON.parse(JSON.stringify(this.form))
          params.companyId = this.companyId
          let url = ''
          if (this.type === 'add') {
            url = '/subAccount/add'
          } else {
            url = '/subAccount/update'
            delete params.password
          }
          this.$http
            .post(url, params)
            .then((res) => {
              if (res.data.code === '200') {
                this.$message.success(res.data.msg)
                this.$router.push('/childrenAccount')
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((e) => {
              console.log(e)
            })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.detail-box {
  .form-box {
    width: 50%;
    padding: 0 25%;
  }

  .info-text {
    color: #6379bb;
    margin-top: 20px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
  }
}
</style>
<style lang="less">
.edit-password {
  .el-form-item {
    margin-bottom: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/businessInfo/account.vue